export enum ProductTier {
	CORE = 'core',
	SUPPORT = 'support',
	INTERNAL = 'internal',
	ARCHIVE = 'archive',
}
